/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.TarifartKosten
 * Tarifart für Kostenermittlung, Werte: Aks = 0; Rrv = 1; Fahrrad = 2; 
 */
export enum TarifartKostenApi {
	Aks = 0,  // Aks
	Rrv = 1,  // Rrv
	Fahrrad = 2  // Fahrrad
};